import { SnackbarProvider, useSnackbar } from "notistack";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function showSuccessSnack(msg) { return showSnack(msg, { variant: "success" }); }
export function showSnack(msg, options) { if (!show)
    throw new Error("missing TSnackbarProvider"); return show(msg, options); }
export function hideSnack(key) { if (!hide)
    throw new Error("missing TSnackbarProvider"); return hide(key); }
export function TSnackbarProvider(props) { return /*#__PURE__*/ _jsxs(SnackbarProvider, { maxSnack: 3, autoHideDuration: 5 * 1000, children: [/*#__PURE__*/ _jsx(TSnackbar, {}), props.children] }); }
var show = null;
var hide = null;
function TSnackbar() { var _a = useSnackbar(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar; show = enqueueSnackbar; hide = closeSnackbar; return null; }
